import { TaskCard, Text } from '@medely/ui-kit';
import React from 'react';
import { TaskCardLayout } from './TaskCard';
import { useProNavigate } from '../../contexts';

export type ProPoolInviteProps = {
  locationId: number;
  facilityName: string;
  professionalQualificationId: number;
  plan: string;
  positionNames: string[];
  onTrackClick?: () => void;
};

export const ProPoolInvite = (props: ProPoolInviteProps) => {
  const {
    locationId,
    facilityName,
    professionalQualificationId,
    plan,
    positionNames,
    onTrackClick,
  } = props;
  const { navigate } = useProNavigate();

  const goToPoolInvite = () => {
    if (onTrackClick) {
      onTrackClick();
    }
    navigate('ProPoolInvite', { locationId, facilityName, professionalQualificationId, plan });
  };

  const positionsString = positionNames.length ? positionNames.join(', ') : null;
  const positionsTitle = positionNames.length === 1 ? 'Position' : 'Positions';

  const ProPoolInviteBody = () => (
    <>
      <Text size="m">{facilityName}</Text>
      {positionsString && (
        <Text size="m">
          {positionsTitle}: {positionsString}
        </Text>
      )}
    </>
  );

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'calendar-check', color: 'tertiary' }}
        title="Exclusive Pro Pool invite"
        body={<ProPoolInviteBody />}
        onClick={goToPoolInvite}
      />
    </TaskCardLayout>
  );
};
